// extracted by mini-css-extract-plugin
module.exports = {"ul":"LanguageApproval_ul__3DJLa","li":"LanguageApproval_li__2O3Eq"};